import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const CancelIcon = ({ color }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>{t('Cancel Icon')}</title>
      <g>
        <circle fill="white" cx="500" cy="491.87" r="475" />
        <g>
          <g>
            <path
              fill={color}
              d="M500,1000c-133.56,0-259.12-52.01-353.55-146.45C52.01,759.12,0,633.56,0,500s52.01-259.12,146.45-353.55
				C240.88,52.01,366.45,0,500,0c133.56,0,259.12,52.01,353.55,146.45C947.99,240.88,1000,366.45,1000,500
				s-52.01,259.12-146.45,353.55C759.12,947.99,633.56,1000,500,1000z M500,67.08c-115.64,0-224.35,45.03-306.12,126.8
				S67.08,384.36,67.08,500c0,115.64,45.03,224.35,126.8,306.12c81.77,81.77,190.48,126.8,306.12,126.8s224.35-45.03,306.12-126.8
				c81.77-81.77,126.8-190.48,126.8-306.12c0-115.64-45.03-224.35-126.8-306.12C724.35,112.11,615.64,67.08,500,67.08z"
            />
          </g>
          <g>
            <g>
              <path
                fill={color}
                d="M499.08,432.21l75.48-130.44h98.93l-121.28,195.3l125.31,201.16h-98.2l-79.15-135.57L421.4,698.23h-98.93
					l125.31-201.16l-120.92-195.3h98.2L499.08,432.21z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CancelIcon;

CancelIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
